import { AdaptationCycleHeader } from '../components/AdaptationCycleHeader'
import HomeContent from '../../../../src/components/SectionContent'

import { adaptationCycleOverview } from '../config/adaptation-cycle-overview.config'
import Callout from '../components/Callout'
import { Link } from 'react-router-dom'

export const AdaptationOverviewPage = () => {
  const {
    stagesIntro,
    stages,
    startHere,
    jurisdictionNote,
    forumCallout,
    mainStages,
    aboutGuidance,
  } = adaptationCycleOverview

  return (
    <div>
      <AdaptationCycleHeader
        adaptationCycle={adaptationCycleOverview}
        children={
          <div className="flex flex-col gap-6">
            <div>
              <h4 className="text-[18px] font-semibold text-primary">{stagesIntro.title}</h4>
              <p className="text-sm">{stagesIntro.description}</p>
            </div>
            <div className="flex flex-wrap gap-5">
              {stages.map((stage, index) => (
                <Link
                  to={'/app/home/adaptation-cycle/' + stage.link}
                  key={stage.title + index}
                  className="min-h-[160px] w-[calc(50%-10px)] bg-[#E0F6FA] p-6 rounded-br-[32px] hover:opacity-80 transition-opacity duration-300"
                >
                  <h6>STAGE {index + 1}</h6>
                  <h5 className="text-[16px] font-semibold">{stage.title}</h5>
                  <p className="text-sm">{stage.description}</p>
                </Link>
              ))}
            </div>
            <a
              href={'#' + startHere.anchor}
              onClick={(e) => {
                e.preventDefault()
                document.getElementById(startHere.anchor)?.scrollIntoView({ behavior: 'smooth' })
              }}
              className="text-sm font-semibold text-primary underline-offset-4 hover:underline w-fit"
            >
              {startHere.label} →
            </a>
            <p className="text-sm">{jurisdictionNote}</p>
            <Callout
              title={forumCallout.title}
              description={forumCallout.description}
              actionLabel={forumCallout.actionLabel}
              onActionClick={() => window.open(forumCallout.href, '_blank', 'noopener,noreferrer')}
            />
          </div>
        }
      />
      <div className="bg-sidebar-accent">
        <HomeContent className="flex flex-col py-6">
          <div className="flex">
            <div className="flex flex-col justify-center w-1/2 mr-6 border-r-4 border-r-primary border-solid">
              <h4 className="text-[18px] font-semibold text-primary">{mainStages.title}</h4>
              <p className="text-sm">{mainStages.description}</p>
            </div>
            <div className="flex w-1/2 gap-6 ml-6">
              {mainStages.stages.map((item, index) => (
                <div key={item.title + index} className="flex flex-col w-1/3">
                  <div className="w-[38px] h-[38px] rounded-full text-[#A3A3A3] flex items-center justify-center pb-2">
                    {item.icon ? <item.icon className="h-[38px] w-[38px]" /> : null}
                  </div>
                  <div>
                    <h5 className="text-sm font-semibold">{item.title}</h5>
                    <p className="text-sm">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <p className="text-sm mt-6">{mainStages.footnote}</p>
        </HomeContent>
      </div>
      <div id={startHere.anchor}>
        <HomeContent className="flex flex-col gap-6 mt-6 pb-12">
          <h4 className="text-[18px] font-semibold text-primary">{aboutGuidance.title}</h4>
          <div className="flex gap-6">
            <div className="flex flex-col gap-6 flex-1">
              {aboutGuidance.paragraphs
                .slice(0, Math.ceil(aboutGuidance.paragraphs.length / 2))
                .map((paragraph, index) => (
                  <p key={index} className="text-sm">
                    {paragraph}
                  </p>
                ))}
            </div>
            <div className="flex flex-col gap-6 flex-1">
              {aboutGuidance.paragraphs
                .slice(
                  Math.ceil(aboutGuidance.paragraphs.length / 2),
                  aboutGuidance.paragraphs.length,
                )
                .map((paragraph, index) => (
                  <p key={index} className="text-sm">
                    {paragraph}
                  </p>
                ))}
            </div>
          </div>
        </HomeContent>
      </div>
    </div>
  )
}
